module.exports = __webpack_public_path__ + "static/media/heart.6c028ab2.svg";